import React, {Component} from 'react';
import {Link} from 'react-router-dom';

class Location extends Component {
  render() {
    let relatedResources;

    if( this.props.relatedResources ) {
//      relatedResources = this.props.relatedResources.map((r) => <Link key={`location-resource-${this.props.id}-${Math.random()}`} to={`https://www.vam.ac.uk/${r.url}`}>{r.type}: {r.title}</Link>);
      relatedResources = this.props.relatedResources.map((r) => <a href={r.url}>{r.type}: {r.title}</a>);
    }

	// We don't have and never will have images for some space types, so
	// don't show a broken image box for them if matches one of those IDs
    return <div className="detail-content">
      {this.props.image && !/FAC(0020|0118|0100|0308|1100|1101|1102|1104|1110|1111|1112|1113|1114|1115|1116|1117)_/.test(this.props.id) &&
        <div className="image">
          <img src={this.props.image[2]} alt=""/>
        </div>
      }

	  { this.props.relatedResources && this.props.relatedResources.length > 0 && 
        <div className="image">
          <img src={this.props.relatedResources[0].icon} alt=""/>
        </div>
      }

      <div className="scroll-pane">

        <div className="title">
          {this.props.title}
        </div>

        {this.props.description && !(this.props.relatedResources && this.props.relatedResources.length > 0) &&
        <div className="description">
          {this.props.description}
        </div>
        }

            <div className="link">
			  {relatedResources} 
            </div>

		{ this.props.relatedResources && this.props.relatedResources.length > 0 && 
 	      <div className="description"> 
			{this.props.relatedResources[0].description}
          </div>

		}


      </div>


    </div>
  }
}

export default Location;
